<template>
	<v-container grid-list-xl>		
		<v-form v-model="isAddValid">
			<v-layout row wrap>
				<v-flex lg12>
					<label class="blackLabel">* Status Description:</label>
					<v-text-field label="Status Description" :rules="nameRules" solo v-model="objRfcStatusEdit.description" single-line required></v-text-field>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Triggers Notifications" v-model="objRfcStatusEdit.triggers_notification"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Data Captured" v-model="objRfcStatusEdit.is_data_captured"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Get Approval" v-model="objRfcStatusEdit.is_get_approval"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Approved" v-model="objRfcStatusEdit.is_accepted"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Denied" v-model="objRfcStatusEdit.is_cancel"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="Reviewed" v-model="objRfcStatusEdit.is_reviewed"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="SR Collection" v-model="objRfcStatusEdit.is_sr_collection_note"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="More Info" v-model="objRfcStatusEdit.is_more_info"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="SR - Received DDC" v-model="objRfcStatusEdit.is_received_ddc"></v-switch>
				</v-flex>			
				<v-flex lg4>
					<v-switch label="SR - Raised" v-model="objRfcStatusEdit.is_sr_raised"></v-switch>
				</v-flex>			
				<v-flex lg4>
					<v-switch label="SR - Cancelled" v-model="objRfcStatusEdit.is_sr_cancelled"></v-switch>
				</v-flex>
				<v-flex lg4>
					<v-switch label="SR - Receipted" v-model="objRfcStatusEdit.is_sr_receipted"></v-switch>
				</v-flex>
				<div class="pl-4 pr-1 pb-2 pt-2 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<!--<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
						<v-btn color="success" class="text-xs-right" :disabled="!isAddValid" @click.stop="fncUpdateStatus()">Update</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>					
				</div>				
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	

	export default {
	  name: 'Settings',
	  data () {
			return {
				runAdd: false,
				isAddValid: false,
				statusDescription: '',
                triggersNotification: '',
                dataCaptured: false,
				getApproval: false,
                approved: false,
				denied: false,
                reviewed: false,
				srCollection: false,
                moreInfo: false,
                receivedDdc: false,
                raised: false,
				cancel: false,
				cancelled: false,
				statusOrder: '',
				nameRules: [
					v => !!v || 'Status name is required',				
				],
				orderRules: [
					v => !!v || 'Status order is required',				
				]				
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncUpdateStatus() {
				this.runAdd = true;
				this.$store.dispatch({
					type: 'fncEditRfcStatus',
					settings: this.objRfcStatusEdit
				});
			},
			fncAltBool(bool) {
			    if( bool == true ) {
			        return 1;
				} else {
			        return 0;
				}
			}
		},
		computed: {
			...mapGetters([			
				'objAuthorize',			
				'statusList',
				'globalModalParams',
                'objRfcStatusEdit'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>